import { render, staticRenderFns } from "./drugList.vue?vue&type=template&id=409f0efe&"
import script from "./drugList.vue?vue&type=script&lang=js&"
export * from "./drugList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports